// extracted by mini-css-extract-plugin
module.exports = {"refox_case_main":"RefoxCaseMain_refox_case_main__3Xyvo","main":"RefoxCaseMain_main__1D_q0","case_nav":"RefoxCaseMain_case_nav__2WrUg"};